// extracted by mini-css-extract-plugin
export default {"wrapper":"Roleformheader_wrapper__Md6dt","createtxt":"Roleformheader_createtxt__+sfvG"};